<template>
    <div>
         <b-row class="mb-2 pr-1">
            <b-col class="pr-1">
                <b-input-group>
                    <b-form-datepicker v-model="filter.filter_date">
                        <template #button-content>
                            <i class="fa fa-calendar" />
                        </template>
                    </b-form-datepicker>
                </b-input-group>
            </b-col>
            <b-col class="mb-2 pr-1">
                <b-input-group prepend="Schedule">
                    <b-form-select
                        v-model="filter.schedule"
                        :options="schedule_options"
                        @change="preFillSchedule"
                    />
                </b-input-group>
            </b-col>
            <b-col class="mb-2 pr-1">
                <b-input-group prepend="Sample Type">
                    <b-form-select
                        v-model="filter.sample_type"
                        :options="sample_type_options"
                        @change="getAnalytes"
                    />
                </b-input-group>
            </b-col>
            <b-col class="mb-2 pr-1">
                <b-input-group prepend="Task Type">
                    <b-form-select
                        v-model="filter.task_type"
                        :options="task_type_options"
                        @change="getTask"
                    />
                </b-input-group>
            </b-col>
            <b-col class="mb-2 pr-1">
                <b-input-group prepend="Task">
                    <b-form-select
                        v-model="filter.task"
                        :options="task_options"
                    />
                </b-input-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="mb-2 pr-1">
                <b-input-group prepend="Status">
                    <b-form-select
                        v-model="filter.status"
                        :options="status_options"
                    />
                </b-input-group>
            </b-col>
            <b-col class="mb-2 pr-1">
                <b-input-group prepend="Analyte">
                    <b-form-select
                        v-model="filter.analyte"
                        :options="analyte_options"
                    />
                </b-input-group>
            </b-col>
            <b-col class="mb-2 pr-1">
                <b-input-group prepend="Instrument">
                    <b-form-select
                        v-model="filter.instrument"
                        :options="instrument_options"
                    />
                </b-input-group>
            </b-col>
            <b-col class="mb-2 pr-1">
                <b-input-group prepend="User">
                    <b-form-select
                        v-model="filter.user"
                        :options="user_options"
                    />
                </b-input-group>
            </b-col>
        </b-row>
        <b-row class="mb-2 pr-1">
            <b-col class="px-1">
                <b-button block @click="applyFilters('apply')">Apply filter</b-button>
            </b-col>
            <b-col class="pr-0 pl-1">
                <b-button block @click="applyFilters('clear')">Clear filters</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import moment from 'moment';
import { getCollection } from "@/shared/fetch-utils";
import { formatModelPath, stripTaskFromName, groupBy } from '@/shared/utils';
import StaffCollection from '@/collections/lab/StaffCollection';

export default {
    name: "BatchResultManagerTableFilters",
    data() {
        return {
            status_options: [
                { value: null, text: " - No State Filter" },
            ],
            sample_type_collection: null,
            sample_type_options: [],
            task_type_options: [
                { value: null, text: " - No Task Type Filter" },
                { value: "App\\Models\\PrepTask", text: "Prep" },
                { value: "App\\Models\\TestTask", text: "Test" },
            ],
            instrument_options: [],
            analyte_options: [],
            task_options: [],
            user_options: [],
            schedule_options: [],
            scheduleCollection: null,
            filter: {
                filter_date: moment().format("YYYY-MM-DD"),
                schedule: null,
                sample_type: null,
                task_type: null,
                task: null,
                status: null,
                analyte: null,
                instrument: null,
                user: null,
            }
        };
    },
    methods: {
        applyFilters(action) {
            if (action === "clear") {
                this.filter.filter_date = moment().format("YYYY-MM-DD");
                this.filter.schedule = null;
                this.filter.sample_type = null;
                this.filter.task_type = null;
                this.filter.task = null;
                this.filter.status = null;
                this.filter.analyte = null;
                this.filter.instrument = null;
                this.filter.user = null;

                this.task_options = [];
                this.analyte_options = [];
            }


            this.emitFilter();
        },
        emitFilter() {
            this.$emit("filterApply", this.filter);
        },
        async getSampleTypeCollection() {
            this.sample_type_collection = await getCollection({
                collection_type: "sample_type",
                message: this.$bvToast,
            });

            const collection_arr = this.sample_type_collection.models.map(({ id, name }) => {
                return { value: id, text: name}
            });

            this.sample_type_options.push({ value: null, text: "- No sample type filter" });
            this.sample_type_options = this.sample_type_options.concat(collection_arr);
        },
        async preFillSchedule() {
            const schedule = this.scheduleCollection.models.filter(i => i.id === this.filter.schedule)[0];
        
            this.filter.sample_type = schedule.sample_type.id;
            this.filter.task_type = `App\\Models\\${schedule.process_type}Task`;

            this.getTask();
            this.getAnalytes();
        },
        async getSchedules() {
            this.scheduleCollection = await getCollection({
                collection_type: "schedule",
                message: this.$bvToast,
                filters: [
                    {
                        logic: "filterEquals",
                        field: "date",
                        value: this.filter.filter_date
                    },
                    {
                        logic: "filterNotEquals",
                        field: "status",
                        value: "Declined"
                    }
                ],
            });
            const schedules = this.scheduleCollection.map(({id, process_type, sample_type}) => {
                return { value: id, text: `${process_type} - ${sample_type.name}` };
            });

            this.schedule_options.push({ value: null, text: "- No Schedule Filter" });
            this.schedule_options = this.schedule_options.concat(schedules);
        },
        async getStatuses() {
            const statuses = await getCollection({
                collection_type: "analyte_result_status",
                message: this.$bvToast
            });

            this.status_options = this.status_options.concat(statuses.map(({id, status}) => {
                if (id && status) {

                    return { value: id, text: status };
                }
            }));
        },
        async getAnalytes() {
            if (!this.filter.sample_type || this.analyte_options.length) {
                this.analyte_options = [];
                this.filter.analyte = null;

                // we only want to return if reseting the sample type
                if (!this.filter.sample_type) {
                    return;
                }
            }

            const sample = this.sample_type_collection.models.filter(i => i.id === this.filter.sample_type)[0];

            const analyteCollection = await getCollection({
                collection_type: "analyte",
                message: this.$bvToast,
                filters: [
                    {
                        logic: "filterEquals",
                        field: "sample_type_id",
                        value: sample.id
                    }
                ]
            });
            const analyte_arr = analyteCollection.map(({id, name}) => {
                return { value: id, text: name };
            });

            this.analyte_options.push({ value: null, text: "- No Analyte Filter" });
            this.analyte_options = this.analyte_options.concat(analyte_arr)
        },
        async getInstruments() {
            // get a list of all instrument instances
            const instrumentCollection = await getCollection({
                collection_type: "instrument_instance",
                message: this.$bvToast,
                limit: "all"
            });

            // Group all instrument instances by same instrument_id
            const groupedInstruments = groupBy(instrumentCollection.models, "instrument_id");

            // push a null filter option at the top of the list
            this.instrument_options.push({value: null, text: "- No Instrument Filter"});

            // for each of the keys in the grouped object
            for (const key in groupedInstruments) {
                // make sure we have the property
                if (!groupedInstruments.hasOwnProperty(key)) {
                    continue;
                }

                // get the instrument name
                const instrumentName = groupedInstruments[key][0].instrument.abbrev;
                
                // create the inital grouped select object with the label added
                let option = { 
                    label: instrumentName
                }
                
                // add the options in the grouped select
                // the option is the array of grouped objects mapped down to the id and name and returned in a way that is expected for bootstrap select blocks
                option.options = groupedInstruments[key].map( ({id, name}) => { return { value: id, text: name } } );

                // push the option to the instrument_options stack
                this.instrument_options.push(option);
            }
        },
        async getUsers() {
            const userCollection = new StaffCollection();
            const userResponse = await userCollection.fetch();
            const users = userResponse.response.data.data;

            this.user_options.push({value: null, text: '- No User Filter'});

            const users_arr = users.map( ({ id, first_name, last_name }) => {
                return { value: id, text: `${first_name} ${last_name}` };
            });

            this.user_options = this.user_options.concat(users_arr);
        },
        async getTask() {
            if (!this.filter.task_type || this.task_options.length) {
                this.task_options = [];
                this.filter.task = null;
                if (!this.filter.task_type) {
                    return;
                }
            }

            const taskCollection = await getCollection({
                collection_type: `${stripTaskFromName(formatModelPath(this.filter.task_type)).toLowerCase()}_task`,
                message: this.$bvToast
            });

            this.task_options.push({ value: null, text: "- No Task Filter" })
            const task_arr = taskCollection.map(({ id, name }) => {
                return { value: id, text: name };
            });

            this.task_options = this.task_options.concat(task_arr);
        },
        async init() {
            this.emitFilter();
            
            this.getSampleTypeCollection();
            this.getUsers();
            this.getSchedules();
            this.getInstruments();
            this.getStatuses();
        },
    },
    mounted() {
        this.init();
    },
};
</script>